import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getSpecificOverrides, getSpecificOvr, getTimeControl, getTimeControls, removeControl, removeOverride, saveOverride, saveTimeControl } from "../../../../modules/ConfigurationModule/services/TimeControlsService";
import { HTTP_RESPONSE_CODES } from "../../../../globals/globals";


export const timeControlsSlice = createSlice({
    name: "timeControls",
    initialState: {
        controls: [],
        idxControls: {},
        idxForms: {},
        drafts: {},
        controlsOnEdition: {},
        controlsBackup: {},

        overrides: {},
        idxOverrides: {},
        idxOvrForms: {},
        ovrBackup: {},
        ovrOnEdition: {},


        loading: false
    },
    reducers: {
        toggleCtrlEdition: (state, action) => {
            let { controlId, toValue } = action.payload;
            return { ...state, controlsOnEdition: { ...state.controlsOnEdition, [controlId]: toValue } }
        },
        toggleOvrEdition: (state, action) => {
            let { ovrId, toValue } = action.payload;
            return { ...state, ovrOnEdition: { ...state.ovrOnEdition, [ovrId]: toValue } }
        },
        discardControlChanges: (state, action) => {
            let { controlId } = action.payload;
            let form = state.idxForms[controlId];
            if (form.version===0) {
                return {...state, controls: state.controls.filter(c => !(c.id === controlId))};
            }
            return {...state, idxForms:{...state.idxForms, [controlId]: state.controlsBackup[controlId]}, controlsOnEdition: {...state.controlsOnEdition, [controlId]: false}};
        },
        discardOvrChanges : (state, action) => {
            let {ovrId} = action.payload;
            return {...state, idxOvrForms:{...state.idxOvrForms, [ovrId]: state.ovrBackup[ovrId]}, ovrOnEdition:{...state.ovrOnEdition, [ovrId]: false}}
        }
        ,
        formChange: (state, action) => {
            let { name, value, controlId } = action.payload;
            let idxControls = { ...state.idxControls };
            if (name === "engineeringTask") {
                idxControls[controlId] = { ...idxControls[controlId], etId: value.id, etName: value.name }
            }
            return { ...state, idxForms: { ...state.idxForms, [controlId]: { ...state.idxForms[controlId], [name]: value } }, idxControls };
        },
        ovrChange: (state, action) => {
            let { name, value, ovrId, completeValue } = action.payload;
            let idxOverrides = { ...state.idxOverrides };
            switch (name) {
                case "accountFleetId":
                    idxOverrides[ovrId] = { ...idxOverrides[ovrId], typeSerie: completeValue.name }
                    break;
                case "aircraftId":
                    idxOverrides[ovrId] = { ...idxOverrides[ovrId], tailNumber: completeValue.tail_number }
                    break;
                case "position":
                    idxOverrides[ovrId] = { ...idxOverrides[ovrId], position: value }
                    break;
                case "nhaId":
                    idxOverrides[ovrId] = { ...idxOverrides[ovrId], nhaPartNumber: completeValue.part_number }
                    break;
                case "nlaPositionId":
                    idxOverrides[ovrId] = { ...idxOverrides[ovrId], nlaPosition: completeValue.position }
                    break;
            }
            return { ...state, idxOvrForms: { ...state.idxOvrForms, [ovrId]: { ...state.idxOvrForms[ovrId], [name]: value } }, idxOverrides };
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchControls.pending, (state, action) => {
            return { ...state, loading: true };
        });
        builder.addCase(fetchControls.fulfilled, (state, action) => {
            let idxControls = Object.fromEntries(action.payload.map(i => [i.id, i]));
            return { ...state, controls: action.payload, idxControls, loading: false }
        });
        builder.addCase(fetchControls.rejected, (state, action) => {
            return { ...state, loading: false };
        });

        // Time controls CRUD
        builder.addCase(createControlDraft.fulfilled, (state, action) => {
            return {
                ...state,
                controls: [action.payload, ...state.controls],
                drafts: { ...state.drafts, [action.payload.id]: true },
                idxForms: { ...state.idxForms, [action.payload.id]: action.payload },
                idxControls: { ...state.idxControls, [action.payload.id]: action.payload },
                controlsOnEdition: { ...state.controlsOnEdition, [action.payload.id]: true }
            }
        });
        builder.addCase(fetchSpecificControl.fulfilled, (state, action) => {
            let { control, overrides } = action.payload;
            let overridesObj = Object.fromEntries(overrides?.map(ovr => [ovr.id, ovr]) ?? []);
            return { ...state, controlsBackup:{...state.controlsBackup, [control.id]: control}, idxForms: { ...state.idxForms, [control.id]: {...control, ...state.idxForms[control.id]} }, overrides: { ...state.overrides, [control.id]: overrides ?? [] }, idxOverrides: { ...state.idxOverrides, ...overridesObj } };
        });
        builder.addCase(saveControl.fulfilled, (state, action) => {
            let { timeControl, closeEdition } = action.payload.load;
            return { ...state, idxForms: { ...state.idxForms, [timeControl.id]: timeControl }, idxControls: { ...state.idxControls, [timeControl.id]: { ...timeControl, etId: timeControl.engineeringTask.id, etName: timeControl.engineeringTask.name } }, controlsOnEdition: { ...state.controlsOnEdition, [timeControl.id]:!closeEdition} };
        });

        builder.addCase(deleteControl.fulfilled, (state, action) => {
            let { controlId } = action.payload;
            return { ...state, controls: state.controls.filter(c => !(c.id === controlId)) }
        });
        //overrides CRUD
        builder.addCase(createOverride.fulfilled, (state, action) => {
            let { ovr, controlId } = action.payload;
            return {
                ...state,
                overrides: { ...state.overrides, [controlId]: [ovr, ...(state.overrides[controlId] ?? [])] },
                idxOverrides: { ...state.idxOverrides, [ovr.id]: ovr },
                idxOvrForms: { ...state.idxOvrForms, [ovr.id]: ovr },
                ovrOnEdition: {...state, [ovr.id]: true}
            };
        });
        builder.addCase(fetchSpecificOverride.fulfilled, (state, action) => {
            let ovr = action.payload;
            return { ...state, idxOvrForms: { ...state.idxOvrForms, [ovr.id]: ovr }, ovrBackup: { ...state.ovrBackup, [ovr.id]: ovr } };
        });
        builder.addCase(saveOverrideCall.fulfilled, (state, action) => {
            let {override, closeEdition } = action.payload.load;
            return { ...state, idxOvrForms: { ...state.idxOvrForms, [override.id]: override }, ovrOnEdition:{...state.ovrOnEdition, [override.id]: !closeEdition} };
        });
        builder.addCase(deleteOverride.fulfilled, (state, action) => {
            let { controlId, ovrId } = action.payload;
            return { ...state, overrides: { ...state.overrides, [controlId]: state.overrides[controlId].filter(c => !(c.id === ovrId)) } }
        });
    }
});

const mockControls = [{
    id: 0
}]


// Time Controls CRUD
export const fetchControls = createAsyncThunk("timeControls/fetchControls",
    async ({ page, part }, { rejectWithValue, getState }) => {
        // return mockControls;
        try {
            let response = await getTimeControls(part);
            if (response.data.responseCode === 200) {
                return response.data.load;
            } else {
                return rejectWithValue(null);
            }
        } catch {
            return rejectWithValue(null);
        }
    }
);

export const fetchSpecificControl = createAsyncThunk("timmeControls/fetchSpecificControls",
    async ({ control }, { rejectWithValue, getState }) => {
        try {
            let response = await getTimeControl(control);
            if (response.data.responseCode === 200) {
                let overridesResponse = await getSpecificOverrides(control);
                if (overridesResponse.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
                    return { control: response.data.load, overrides: overridesResponse.data.load }
                }
                return { control: response.data.load };
            } else {
                return rejectWithValue(null);
            }

        } catch {
            return rejectWithValue(null)
        }
    }
)

export const createControlDraft = createAsyncThunk("timeControls/createControlDraft",
    async ({ part }, { rejectWithValue, getState }) => {
        // TODO: try
        let response = await saveTimeControl({ id: null, part });
        if (response.data.responseCode === HTTP_RESPONSE_CODES.CREATED) {
            return response.data.load;
        } else {
            return rejectWithValue(null);
        }
    }
);

export const deleteControl = createAsyncThunk("timeControls/deleteControl",
    async ({ controlId }, { rejectWithValue, getState }) => {
        //TODO: try
        let response = await removeControl(controlId);
        if (response.data.responseCode === HTTP_RESPONSE_CODES.DELETED) {
            return { controlId };
        } else {
            return rejectWithValue(false);
        }
    }
)

export const saveControl = createAsyncThunk("timeControls/saveTimeControl",
    async ({ controlId, part, closeEdition }, { rejectWithValue, getState }) => {
        let { idxForms } = getState().timeControls;
        let controlToSave = idxForms[controlId];
        // TODO: try
        try {
            let response = await saveTimeControl({ ...controlToSave, part: controlToSave.part ?? part });
            if (response.data.responseCode === HTTP_RESPONSE_CODES.UPDATED) {
                return { load: {timeControl: response.data.load, closeEdition}, response:response.data }
            } else {
                return rejectWithValue({response: response.data});
            }
        } catch (error) {
            return rejectWithValue(error);
        }
    }
)

// CRUD overrides
export const createOverride = createAsyncThunk("timeControls/createOverride",
    async ({ controlId }, { rejectWithValue, getState }) => {
        // TODO: try
        let response = await saveOverride({ id: null, etControlId: controlId });
        if (response.data.responseCode === HTTP_RESPONSE_CODES.CREATED) {
            return { ovr: response.data.load, controlId };
        } else {
            return rejectWithValue(null);
        }
    }
);

export const fetchSpecificOverride = createAsyncThunk("timeControls/fetchSpecificOverride",
    async ({ ovrId }, { rejectWithValue, getState }) => {
        // TODO: try
        let response = await getSpecificOvr(ovrId);
        if (response.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
            return response.data.load;
        } else {
            return rejectWithValue(null);
        }
    }
)

export const saveOverrideCall = createAsyncThunk("timeControls/saveOverrideCall",
    async ({ ovrId, controlId, closeEdition }, { rejectWithValue, getState }) => {
        let { idxOvrForms } = getState().timeControls;
        let ovrToSave = idxOvrForms[ovrId];
        // TODO: try
        try {
            let response = await saveOverride({ ...ovrToSave, etControlId: controlId });
            if (response.data.responseCode === HTTP_RESPONSE_CODES.UPDATED) {
                return {load:{override: response.data.load, closeEdition}, response: response.data}
            } else {
                return rejectWithValue({response: response.data});
            }
        } catch (error) {
            return rejectWithValue(error);
        }
    }
)

export const deleteOverride = createAsyncThunk("timeControls/deleteOverride",
    async ({ ovrId, controlId }, { rejectWithValue, getState }) => {
        //TODO: try
        let response = await removeOverride(ovrId);
        if (response.data.responseCode === HTTP_RESPONSE_CODES.DELETED) {
            return { ovrId, controlId };
        } else {
            return rejectWithValue(false);
        }
    }
)

export const { formChange, ovrChange, toggleCtrlEdition, toggleOvrEdition, discardControlChanges, discardOvrChanges } = timeControlsSlice.actions;
export const selectTimeControls = (state) => state.timeControls.controls;
export const selectIdxControls = (state) => state.timeControls.idxControls;
export const selectTimeCtrlLoading = (state) => state.timeControls.loading;
export const selectIdxForms = (state, timeCtrlId) => state.timeControls.idxForms[timeCtrlId];
export const selectOvrForm = (state, ovrId) => state.timeControls.idxOvrForms[ovrId];
export const selectOvrBackup = (state, ovrId) => state.timeControls.ovrBackup[ovrId];
export const selectOverrides = (state, timeCtrlId) => state.timeControls.overrides[timeCtrlId];
export const selectIdxOverride = (state, ovrId) => state.timeControls.idxOverrides[ovrId];
export const selectEditingControl = (state, ctrlId) => state.timeControls.controlsOnEdition[ctrlId];
export const selectEditingOvr = (state, ovrId) => state.timeControls.ovrOnEdition[ovrId];
export default timeControlsSlice.reducer;
